// tslint:disable:max-line-length

import React from 'react';

export const UtilityAdmin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.5 0c-2.485 0-4.5 2.015-4.5 4.5 0 .452.095.87.219 1.281l-7.219 7.219v3h3v-2h2v-2h2v-2h2l1.219-1.219c.411.124.829.219 1.281.219 2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zm1.5 2c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" />
    </svg>
  );
};
